import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface ExporterUtilisateursInput {
  role?: string;
  isActive?: string;
}

export class ExporterUtilisateursUseCase implements IUseCase<ExporterUtilisateursInput, Blob> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: ExporterUtilisateursInput): Promise<Blob> {
    return this.repository.exporterUtilisateurs(input);
  }
}
